<script>
import {Line} from 'vue-chartjs'
import {trans} from "../../../app";
import {getColor} from "../../../utils/colors";

export default {
    extends: Line,
    methods: {
        setOrdersData(ordersData) {
            this.ordersData = ordersData;
            this.renderChart({
                labels: this.labels,
                datasets: this.datasets,
            }, this.options);
        }
    },
    data: () => ({
        ordersData: [],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                }
            },
        }
    }),
    computed: {
        datasets() {
            let datasets = [
                {
                    label: trans('app.statistics.orders.aggregated_amount'),
                    data: this.ordersData.map((row) => {
                        return row.aggregated_amount;
                    }),
                },
            ];
            datasets = datasets.map((dataset, index) => {
                dataset.borderColor = getColor(index)
                return dataset;
            })
            return datasets;
        },
        labels() {
            return this.ordersData.map((row) => {
                return row.date
            });
        }
    },
    mounted() {
        this.renderChart({
            labels: this.labels,
            datasets: this.datasets
        }, this.options)
    }
}
</script>